import { render, staticRenderFns } from "./NewVersionNotification.vue?vue&type=template&id=3d20a4e6"
import script from "./NewVersionNotification.vue?vue&type=script&lang=js"
export * from "./NewVersionNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports